/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CurrentManagerUpdateRequest,
  PutApiCurrentManagerUpdate200,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type putApiCurrentManagerUpdateResponse200 = {
  data: PutApiCurrentManagerUpdate200
  status: 200
}

export type putApiCurrentManagerUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiCurrentManagerUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiCurrentManagerUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiCurrentManagerUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiCurrentManagerUpdateResponseSuccess = (putApiCurrentManagerUpdateResponse200) & {
  headers: Headers;
};
export type putApiCurrentManagerUpdateResponseError = (putApiCurrentManagerUpdateResponse400 | putApiCurrentManagerUpdateResponse401 | putApiCurrentManagerUpdateResponse403 | putApiCurrentManagerUpdateResponse409) & {
  headers: Headers;
};

export type putApiCurrentManagerUpdateResponse = (putApiCurrentManagerUpdateResponseSuccess | putApiCurrentManagerUpdateResponseError)

export const getPutApiCurrentManagerUpdateUrl = () => {


  

  return `/api/manager`
}

export const putApiCurrentManagerUpdate = async (currentManagerUpdateRequest: CurrentManagerUpdateRequest, options?: RequestInit): Promise<putApiCurrentManagerUpdateResponse> => {
  
  return customFetch<putApiCurrentManagerUpdateResponse>(getPutApiCurrentManagerUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      currentManagerUpdateRequest,)
  }
);}


